import type { CrudSearchItem, CrudTableColumn } from '@/types/crud-config'
import type { ChannelRecord } from './channel.service'

export const channelSearchItems: CrudSearchItem[] = [
  {
    label: '标题',
    prop: 'eventName',
    type: 'input',
    controlClass: 'channel-page__search-input',
    clearable: true,
    placeholder: '请输入标题'
  }
]

export function createChannelTableColumns(
  showQrCode: boolean
): CrudTableColumn<ChannelRecord>[] {
  const columns: CrudTableColumn<ChannelRecord>[] = [
    {
      prop: 'eventName',
      label: '直播间',
      slot: 'channel',
      minWidth: 180,
      align: 'left'
    },
    {
      prop: 'liveUrl',
      label: '打开直播间',
      slot: 'liveUrl',
      minWidth: 120
    },
    {
      prop: 'rowId',
      label: '复制链接',
      slot: 'copy',
      minWidth: 120
    }
  ]

  if (showQrCode) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      minWidth: 120
    })
  }

  return columns
}
